import {ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

require('./planning-draft-route-job-split-revert.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-route-job-split-revert',
  templateUrl: './planning-draft-route-job-split-revert.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftRouteJobSplitRevertComponent implements OnInit {

  public jobSuggestions: any;
  public otherJobRoute: any;
  public otherSubJob: any;
  public isCurrentJobInLockedRoute: boolean;
  public isOtherJobInLockedRoute: boolean;
  public isAnyJobDispatched: boolean;
  public isUndoBlockedByStep: boolean;

  @Output() onClose = new EventEmitter();
  @Output() onReverseJobSplit = new EventEmitter<string>();

  originalJob: any;
  subJobs: any[] = [];
  suggestionInformation: any;
  isAnySubJobInLockedRoute: boolean;

  constructor(@Inject(PANEL_DATA) public data: { jobSuggestions: any, otherJobRoute: any, otherSubJob: any,
                isCurrentJobInLockedRoute: boolean, isOtherJobInLockedRoute: boolean, isAnyJobDispatched: boolean}) {
  }

  ngOnInit() {
    this.jobSuggestions = this.data.jobSuggestions;
    this.otherJobRoute = this.data.otherJobRoute
    this.otherSubJob = this.data.otherSubJob;
    this.isCurrentJobInLockedRoute = this.data.isCurrentJobInLockedRoute;
    this.isOtherJobInLockedRoute = this.data.isOtherJobInLockedRoute;
    this.isAnyJobDispatched = this.data.isAnyJobDispatched;

    this.isUndoBlockedByStep = !!this.jobSuggestions.suggestionInformation.undoBlockedByStepAt;
    this.originalJob = this.jobSuggestions.suggestionInformation.originalJobSnapshot;
    this.subJobs = this.jobSuggestions.suggestionInformation.subJobs;
    this.isAnySubJobInLockedRoute = this.isCurrentJobInLockedRoute || this.isOtherJobInLockedRoute;
  }

  close() {
    this.onClose.emit();
  }

  canReverseSplit() {
    return !(this.isAnySubJobInLockedRoute || this.isAnyJobDispatched || this.isUndoBlockedByStep)
  }

  reverseJobSplit() {
    if(!this.canReverseSplit()) return;
    this.onReverseJobSplit.emit(this.jobSuggestions.id);
    this.close();
  }
}
